/* ═══════════════════════════════════════════════════════════════════════
   Capturas reales de la app
   ═══════════════════════════════════════════════════════════════════════

   El fold «Así se ve por dentro» enseñaba maquetas dibujadas a mano en HTML.
   Estaban bien hechas y su comentario defendía la decisión (nítidas a
   cualquier densidad, ligeras, animables), pero una maqueta dibujada siempre
   se lee como una promesa. Estas son pantallas de la aplicación de verdad, y
   eso vale más en el sitio donde alguien decide si te cree.

   Se generan desde los PNG originales del equipo (ver `capturas-fuente/` en la
   raíz, fuera de `public/` a propósito: son masters de 4 MB que no tienen por
   qué viajar a producción). El guion de generación recorta y convierte.

   Dos decisiones que conviene no deshacer sin motivo:

   · TODAS salen a 1.75:1. Viven una encima de otra dentro del mismo marco
     pegado y se relevan con un fundido; con proporciones distintas el marco
     cambiaría de altura a mitad del fundido y el texto de al lado saltaría.

   · Se les quita la barra lateral de navegación de la app. No aporta a ningún
     mensaje de esta página, y en una columna de 600 px se llevaba el 11 % del
     ancho que necesita el contenido para leerse.

   Formato WebP con calidad 86, medido sobre la captura más difícil (la del
   mapa) a 1200 px de ancho:
       PNG plano ............ 318 KB
       WebP sin pérdida ..... 204 KB
       AVIF (crf 28) ......... 58 KB
       WebP q86 .............. 50 KB   ← este
   A 86 el texto de la interfaz se ve idéntico al sin pérdida comparando
   recortes a 1:1, y pesa la cuarta parte. AVIF salía MÁS pesado aquí y además
   tiende a emborronar tipografía pequeña, que es justo de lo que están hechas
   estas imágenes.
   ═══════════════════════════════════════════════════════════════════════ */

export interface Captura {
    src: string;
    srcSet: string;
    /** CLAVE del diccionario, no el texto (ver media.ts). */
    alt: string;
}

/** Ancho y alto reales del archivo. Van al `<img>` para que el navegador
 *  reserve el hueco antes de descargar y la página no dé un salto. */
export const CAPTURA_ANCHO = 1640;
export const CAPTURA_ALTO = 936;

function captura(nombre: string, alt: string): Captura {
    return {
        src: `/app/${nombre}-1200.webp`,
        srcSet: `/app/${nombre}-760.webp 760w, /app/${nombre}-1200.webp 1200w`,
        alt,
    };
}

/** Estimados: la propuesta que ve el cliente, el desglose y la firma. */
export const ESTIMADOS: Captura[] = [
    captura(
        'estimado-propuesta',
        'lp.alt.cap.propuesta',
    ),
    captura(
        'estimado-desglose',
        'lp.alt.cap.partidas',
    ),
    captura(
        'estimado-firma',
        'lp.alt.cap.firma',
    ),
];

/** Equipo: quién está en el reloj y dónde fichó. */
export const EQUIPO: Captura[] = [
    captura(
        'equipo-reloj',
        'lp.alt.cap.reloj',
    ),
    captura(
        'equipo-mapa',
        'lp.alt.cap.mapa',
    ),
];

/** Rutas: el día de la cuadrilla, en orden. */
export const RUTAS: Captura[] = [
    captura(
        'ruta-dia',
        'lp.alt.cap.rutas',
    ),
    captura(
        'ruta-parada',
        'lp.alt.cap.parada',
    ),
];

/** Raza AI: la pregunta del contratista y lo que le contesta. */
export const IA: Captura[] = [
    captura(
        'ia-alcance',
        'lp.alt.cap.ia',
    ),
];
